var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        {
          ref: "listStructureDetail",
          attrs: {
            model: _vm.structure,
            rules: _vm.listStructureRules,
            "label-width": "120px",
          },
        },
        [
          _c("q-form-generator", {
            attrs: { "form-structure": _vm.formStructure },
            model: {
              value: _vm.structure,
              callback: function ($$v) {
                _vm.structure = $$v
              },
              expression: "structure",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "q-button",
            { attrs: { type: "primary" }, on: { click: _vm.updateStructure } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(this.$qt("listStructure.confirmSetting")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "q-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(this.$qt("listStructure.rejectSetting")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }